import { Component, forwardRef, ViewEncapsulation, Input } from '@angular/core';
import { NexusComponent } from '../nexus/nexus.component';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'nexus-editor',
  templateUrl: './nexus-editor.component.html',
  styleUrls: ['./nexus-editor.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => NexusEditorComponent),
    }
  ]
})
export class NexusEditorComponent extends NexusComponent implements ControlValueAccessor {
  @Input() public formControlName: string;
  public is_disabled: boolean = false;
  public loaded: boolean = false;
  public control: UntypedFormControl = new UntypedFormControl();
 
  private load = () => {
    this.loaded = true;
  }

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    setTimeout(this.load, 250); //super hacky but required to fix bug https://github.com/tinymce/tinymce-angular/issues/76
    
    this.control.valueChanges.subscribe((data: any) => {
      this.propagateChange(data);
    });
  }

  private propagateChange = (value: any) => { };

  writeValue(obj: any): void {
    this.control.setValue(obj);
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {

  }

  setDisabledState?(isDisabled: boolean): void {
    this.is_disabled = isDisabled;
  }

}
